import { render, staticRenderFns } from "./IpServer.vue?vue&type=template&id=d1f2fb90&scoped=true&"
import script from "./IpServer.vue?vue&type=script&lang=js&"
export * from "./IpServer.vue?vue&type=script&lang=js&"
import style0 from "./IpServer.vue?vue&type=style&index=0&id=d1f2fb90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f2fb90",
  null
  
)

export default component.exports